import React from "react";
import { Link } from "react-router-dom";

const CARDS = [
  {
    to: "/reflections-screens/category-reflections",
    title: "Category reflections",
    description: "Screens 2–6 copy: 5 categories × 4 levels (Significant Growth, Growing, Holding Steady, A Gentle Focus)."
  },
  {
    to: "/reflections-screens/overall-reflections",
    title: "Overall reflections",
    description: "Screen 7 copy: one paragraph per internal profile. Parents never see the profile key."
  },
  {
    to: "/reflections-screens/static-screens",
    title: "Static screens",
    description: "Fixed journey screens: beginning/end intro, welcome, one final thought, keep going."
  }
];

export default function ReflectionsScreensHub() {
  return (
    <div className="page-content content">
      <div className="page-header-row toolbar" style={{ marginBottom: 16 }}>
        <div>
          <h2 className="page-title" style={{ margin: 0 }}>
            Reflections & screens
          </h2>
          <p className="page-subtitle">
            Family Growth Snapshot journey content. Pick a type to manage list, add, and edit.
          </p>
        </div>
      </div>

      <div style={{ display: "grid", gap: 16, gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))" }}>
        {CARDS.map((card) => (
          <Link
            key={card.to}
            to={card.to}
            className="card"
            style={{ textDecoration: "none", color: "inherit", display: "block", padding: 20 }}
          >
            <h3 className="section-title" style={{ marginTop: 0 }}>
              {card.title}
            </h3>
            <p className="small-label" style={{ marginBottom: 12 }}>
              {card.description}
            </p>
            <span className="action-link">Open list →</span>
          </Link>
        ))}
      </div>
    </div>
  );
}
